export default (getView) =>
  ({ nextStepPath, formFields }) => ({
    ...getView({
      nextStepPath,
      formFields,
    }),

    init() {
      this.commonInit()

      this.store.values.marketingAgreed = false
      this.store.values.privacyAgreement = false
    },

    handleSubmit() {
      // Agreements are set here automatically as per products requirement.
      // On UI there is a text that user agrees by pressing 'next' button.
      this.store.values.marketingAgreed = true
      this.store.values.privacyAgreement = true

      const prevEmail = this.store.values.email
      const currentEmail = this.formValues.email

      this.submit({ push: true, isTrackingResetNeeded: currentEmail !== prevEmail })
    },
  })
